import {
  baseMethods,
  DateTimeResult,
  ResultType,
  ResultTypesEnum,
  StringResult,
  TeammateListResult,
  TeammateResult,
} from './internal';

export const commentType: ResultType = {
  name: ResultTypesEnum.COMMENT,
  properties: {
    id: StringResult,
    date: DateTimeResult,
    author: TeammateResult,
    body: StringResult,
    mentions: TeammateListResult,
  },
  methods: {
    ...baseMethods,
  },
};
